import { FormatUtility } from '@codequality/vue-cli-base';

export default class AppFormatUtility {
  private constructor() {
    // 呼び出し禁止
  }

  /**
   * 日時を'YYYY/MM'形式にフォーマット
   *
   * @param value
   * @returns
   */
  public static formatYm(value: string | number | null | undefined): string {
    return FormatUtility.formatDateTime(value, 'YYYY/MM');
  }

  /**
   * 日時を'YYYY年M月'形式にフォーマット
   *
   * @param value
   * @returns
   */
  public static format年月(value: string | number | null | undefined): string {
    return FormatUtility.formatDateTime(value, 'YYYY年M月');
  }

  /**
   * 日時を'YYYY年M月期'形式にフォーマット
   * 指定により'YYYY年'と'M月期'の間に改行をいれます
   *
   * @param value
   * @param isWithNL
   * @returns
   */
  public static format年月期(value: string | number | null | undefined, isWithNL = false): string {
    const format = `YYYY年${isWithNL ? '\n' : ''}M月期`;
    return FormatUtility.formatDateTime(value, format);
  }

  /**
   * 日時を'YYYYMM'形式の数値に変換します
   *
   * @param value
   * @returns
   */
  public static parse年月Number(value: string | number | null | undefined): number {
    return Number(FormatUtility.formatDateTime(value, 'YYYYMM'));
  }

  /**
   * 数値を指定の単位に変換します（四捨五入）
   *
   * @param value
   * @param unit
   * @returns
   */
  public static changeUnit(value: number | null | undefined, unit: number | null): number {
    if (value === null || value === undefined) return 0;
    return unit === null ? value : Math.round(value / unit);
  }
}
